import {
	RFQ_LIST_SR,
	RFQ_LIST_SR_SUCCESS,
	SELECT_CHANGEVALUE_SR,
	RFQ_ROW_DATA_SR,
	RFQ_ROW_DATA_SR_SUCCESS,
	QUOTATION_ROW_DATA_SR,
	QUOTATION_ROW_DATA_SR_SUCCESS,
	QUOTATION_CHECKED_SR,
	APPROVED_QUANTITY_SR,
	RESET_CELL_UPDATE,
	SR_COMPARE_QUOTATION_ADD,
	SR_COMPARE_QOUTATION_DATA,
	SR_COMPARE_QOUTATION_DATA_SUCCESS,
	SR_COMPARE_QOUTATION_LIST,
	SR_COMPARE_QOUTATION_LIST_SUCCESS,
	SET_SR_PARAMS,
	FILTER_INPUT_CHANGEVALUE_SR,
	FILTER_SELECT_CHANGEVALUE_SR,
	GENERATE_PURCHASE_ORDER_SR,
	GENERATE_PURCHASE_ORDER_SR_RESPONSE,
	PURCHASE_ORDER_SR_LIST,
	PURCHASE_ORDER_SR_LIST_SUCCESS,
	PURCHASE_ORDER_SR_DATA,
	TOGGLE_SR_ITEM_MENU,
	SR_LIST_LAYOUT,
	FILTERS_SHOW_SR_RIGHT_SIDEBAR,
	FILTERS_HIDE_SR_RIGHT_SIDEBAR,
	CLEAR_FILTER,
	SR_PO_MODEL_CLOSE,
	SR_PO_MODEL_OPEN,
	SR_PO_VEND_DATA,
	INPUT_CHANGEVALUE_SR,
	SR_PO_SELECT_CHANGEVALUE_SR,
	RESET_SUBLOCATION,
} from "./actionTypes";

const initialState = {
	rfqList: [],
	CQData: {},
	RFQrowdata: [],
	Quotations: [],
	RFQCellData: [],
	CQbodyData: [],
	CQBodyTCData: [],
	CQRowData: [],
	CQRowList: [],
	CQPOList: [],
	POData: [],
	loading: false,

	HideSubmiteData: false,
	newclm: "",
	newrow: -1,
	CQRowListCount: 0,
	Sortvar: {
		code: "QUOTATION NO",
		createdon: "CREATED ON",
	},
	params: {
		no_of_pages: 0,
		page_size: 10,
		page: 1,
		search: "",
		currentSort: "code",
		sortOrder: "-",
	},
	layout: "list",

	showFilterRightSidebar: false,
	SR_PO_Model: false,
	SR_PO_ID: null,

	PORowData: {},
	SR_PO_index: null,
	sublocationslist2: { results: [] },
};

const SRCompareQuotation = (state = initialState, action) => {
	switch (action.type) {
		case RFQ_LIST_SR:
			state = {
				...state,
				loading: true,
			};
			break;
		case RFQ_LIST_SR_SUCCESS:
			state = {
				...state,
				rfqList: action.payload,
				loading: false,
			};
			break;
		case SELECT_CHANGEVALUE_SR:
			state = {
				...state,
				CQData: {
					...state.QRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case RFQ_ROW_DATA_SR:
			state = {
				...state,
				loading: true,
			};
			break;
		case RFQ_ROW_DATA_SR_SUCCESS:
			state.RFQCellData = [
				{ vendId: 0, CellName: "ItemName", headerName: "Item Name" },
			];

			var srfqvendors = action.payload.srfqvendors.sort(function (a, b) {
				return b.loginstatus - a.loginstatus;
			});

			srfqvendors.map((vend, i) => {
				var Hcelldata = {
					CellName: "Vendor" + vend.vendor.id,
					headerName: vend.vendor.name,
					vendId: vend.vendor.id,
				};
				state.RFQCellData.push(Hcelldata);
				return 0;
			});

			state.CQbodyData = action.payload.srfqitems.map((item) => {
				return {
					ItemName: {
						rfqItemId: item.id,
						product_id: item.product.id,
						Name: item.product.name,
						Quantity: item.qty,
						Quantity_unit: {
							units: item.unit.units,
							name: item.unit.name,
						},
						make: item.make,
						description: item.description,
						totalqty: 0,
						totalpoqty: 0,
					},
				};
			});

			state = {
				...state,
				RFQrowdata: action.payload,
			};
			break;
		case QUOTATION_ROW_DATA_SR:
			state = {
				...state,
			};
			break;
		case QUOTATION_ROW_DATA_SR_SUCCESS:
			state.Quotations = action.payload;
			var rfqItemIds = state.CQbodyData.map((item) => {
				return item.ItemName.rfqItemId;
			});
			state.CQBodyTCData = [
				{ ItemName: "Terms & Conditions" },
				{ ItemName: "Other Details" },
			];
			action.payload.forEach((q, key) => {
				q.sqitems.forEach((item, j) => {
					
					var i = rfqItemIds.indexOf(item.srfqitem);
					state.CQbodyData[i]["Vendor" + q?.vendor?.id] = {
						Quantity: item?.originalqty,
						unit: { id: item?.unit?.id, name: item?.unit?.name },
						baseprice: item?.baseprice,
						discount: item?.discount,
						discountpercent: item?.discountpercent,
						Price: item?.price,
						GrossValue: item?.gross,
						GST: item?.tax?.name,
						tax: item?.tax?.tax,
						tax_id: item?.tax?.id,
						taxtype: item?.taxtype,
						taxamount: 0,
						qitem_taxamount: item?.taxamount,
						qitem_id: item?.id,
						make: item?.make,
						description: item?.description,
						po_qty: 0,
						ApprovedQuantity: 0,
						updateGrossValue: 0,
						index: i,
						quotation_id: q.id,
						vendorId: q?.vendor?.id,
						Quotationcheck: false,
					};
					if (
						q.sqitems.length - 1 === j &&
						action.payload.length - 1 === key
					) {
						state.loading = false;
						// state.RFQCellData
					}
				});
				state.CQBodyTCData[0]["Vendor" + q.vendor.id] = q.terms;
				state.CQBodyTCData[1]["Vendor" + q.vendor.id] = q.description;
				if (state.CQRowData.scqitems) {
					if (key + 1 === action.payload.length) {
						state.CQRowData.scqitems.forEach((item, index) => {
							var i = rfqItemIds.indexOf(item.srfqitem);
							if (item.scqstatus === 2) {
								state.CQbodyData[i]["Vendor" + item.vendor.id][
									"id"
								] = item.id;
								state.CQbodyData[i]["Vendor" + item.vendor.id][
									"ApprovedQuantity"
								] = item.qty;
								state.CQbodyData[i]["Vendor" + item.vendor.id][
									"Quotationcheck"
								] = true;
								state.CQbodyData[i]["Vendor" + item.vendor.id][
									"updateGrossValue"
								] = item.gross;
								state.CQbodyData[i]["Vendor" + item.vendor.id][
									"taxamount"
								] = item.taxamount;
								state.CQbodyData[i]["ItemName"]["totalqty"] +=
									parseFloat(parseFloat(item.qty).toFixed(3));
							} else if (item.scqstatus === 3) {
								if (
									!state.CQbodyData[i][
										"Vendor" + item.vendor.id
									]["old_list"]
								) {
									state.CQbodyData[i][
										"Vendor" + item.vendor.id
									]["old_list"] = [];
								}
								state.CQbodyData[i]["Vendor" + item.vendor.id][
									"old_list"
								].push({
									id: item.id,
									ApprovedQuantity: item.qty,
									updateGrossValue: item.gross,
								});

								if (
									!state.CQbodyData[i][
										"Vendor" + item.vendor.id
									]["po_qty"]
								) {
									state.CQbodyData[i][
										"Vendor" + item.vendor.id
									]["po_qty"] = 0;
								}
								state.CQbodyData[i]["Vendor" + item.vendor.id][
									"po_qty"
								] += parseFloat(
									parseFloat(item.qty).toFixed(3)
								);

								state.CQbodyData[i]["ItemName"]["totalpoqty"] +=
									parseFloat(parseFloat(item.qty).toFixed(3));
								state.CQbodyData[i]["ItemName"]["totalpoqty"] =
									parseFloat(
										parseFloat(
											state.CQbodyData[i]["ItemName"][
												"totalpoqty"
											]
										).toFixed(3)
									);
							}
						});
					}
				}

				// state.CQPOList.forEach((po, key) => {
				//   po.poitems.forEach((item, j) => {

				//     var i = rfqItemIds.indexOf(item.srfqitem);

				//     if(!state.CQbodyData[i]["Vendor" + po.vendor.id]["po_qty"]){
				//       state.CQbodyData[i]["Vendor" + po.vendor.id]["po_qty"] = 0
				//     }

				//     state.CQbodyData[i]["Vendor" + po.vendor.id]["po_qty"] += item.qty;
				//   });
				// });
			});

			if (action.payload.length === 0) {
				state.loading = false;
			}
			break;
		case QUOTATION_CHECKED_SR:
			var vendorId = action.payload.vendorId;
			var index = action.payload.index;
			state.CQbodyData[index]["Vendor" + vendorId]["Quotationcheck"] =
				action.payload.checked;
			if (action.payload.checked === false) {
				state.CQbodyData[index]["ItemName"]["totalqty"] -= parseInt(
					state.CQbodyData[index]["Vendor" + vendorId][
						"ApprovedQuantity"
					]
				);
				state.CQbodyData[index]["Vendor" + vendorId][
					"ApprovedQuantity"
				] = 0;
				state.CQbodyData[index]["Vendor" + vendorId][
					"updateGrossValue"
				] = 0;
				state.CQbodyData[index]["Vendor" + vendorId]["taxamount"] = 0;

				state.CQbodyData[index]["Vendor" + vendorId]["dodelete"] = true;
			} else {
				state.CQbodyData[index]["Vendor" + vendorId][
					"dodelete"
				] = false;
			}

			state.newclm = "Vendor" + vendorId;
			state.newrow = index;
			break;

		case APPROVED_QUANTITY_SR:
			var vendorId1 = action.payload.vendorId;
			var index1 = action.payload.index;

			var ApprovedQuantity =
				action.payload.ApprovedQuantity !== ""
					? action.payload.ApprovedQuantity
					: 0;
			var gross =
				state.CQbodyData[index1]["Vendor" + vendorId1]["Price"] *
				ApprovedQuantity;
			var taxamt = 0;
			if (
				state.CQbodyData[index1]["Vendor" + vendorId1]["taxtype"] === 1
			) {
				var basicValue =
					gross /
					((100 +
						state.CQbodyData[index1]["Vendor" + vendorId1]["tax"]) /
						100);
				taxamt =
					(basicValue / 100) *
					state.CQbodyData[index1]["Vendor" + vendorId1]["tax"];
				var netValue = parseFloat(
					parseFloat(basicValue + taxamt).toFixed(3)
				);
			} else {
				taxamt =
					(gross *
						state.CQbodyData[index1]["Vendor" + vendorId1]["tax"]) /
					100;
				netValue = parseFloat(parseFloat(gross + taxamt).toFixed(3));
			}

			state.CQbodyData[index1]["ItemName"]["totalqty"] -= parseFloat(
				parseFloat(
					state.CQbodyData[index1]["Vendor" + vendorId1][
						"ApprovedQuantity"
					]
				).toFixed(3)
			);
			state.CQbodyData[index1]["ItemName"]["totalqty"] = parseFloat(
				parseFloat(
					state.CQbodyData[index1]["ItemName"]["totalqty"]
				).toFixed(3)
			);

			state.CQbodyData[index1]["Vendor" + vendorId1]["ApprovedQuantity"] =
				ApprovedQuantity;
			state.CQbodyData[index1]["Vendor" + vendorId1]["updateGrossValue"] =
				netValue;
			state.CQbodyData[index1]["Vendor" + vendorId1]["taxamount"] =
				parseFloat(taxamt).toFixed(3);

			state.CQbodyData[index1]["ItemName"]["totalqty"] += parseFloat(
				parseFloat(ApprovedQuantity).toFixed(3)
			);
			state.CQbodyData[index1]["ItemName"]["totalqty"] = parseFloat(
				parseFloat(
					state.CQbodyData[index1]["ItemName"]["totalqty"]
				).toFixed(3)
			);

			state.newclm = "Vendor" + vendorId1;
			state.newrow = index1;
			break;
		case RESET_CELL_UPDATE:
			state = {
				...state,
				newclm: initialState.newclm,
				newrow: initialState.newrow,
			};
			break;
		case SR_COMPARE_QUOTATION_ADD:
			state = {
				...state,
				loading: true,
			};
			break;
		case SR_COMPARE_QOUTATION_DATA:
			state = {
				...state,
				loading: true,
			};
			break;
		case SR_COMPARE_QOUTATION_DATA_SUCCESS:
			state = {
				...state,
				CQRowData: action.payload,

				loading: false,
			};
			break;
		case SR_COMPARE_QOUTATION_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case SR_COMPARE_QOUTATION_LIST_SUCCESS:
			var noofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);
			state = {
				...state,
				CQRowList: action.payload.results,
				CQRowListCount: action.payload.count,

				params: {
					...state.params,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			break;
		case SET_SR_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;
		case FILTER_INPUT_CHANGEVALUE_SR:
			state = {
				...state,
				params: {
					...state.params,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case FILTER_SELECT_CHANGEVALUE_SR:
			state = {
				...state,
				filterdata: {
					...state.filterdata,
					[action.payload.key]: action.payload.label,
				},
				params: {
					...state.params,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case TOGGLE_SR_ITEM_MENU:
			var CQRowList = state.CQRowList?.map((i) => {
				if (i.id === action.payload) {
					i.actionMenu = !i.actionMenu;
				} else {
					i.actionMenu = false;
				}
				return i;
			});

			state = {
				...state,
				CQRowList: CQRowList,
			};
			break;

		case PURCHASE_ORDER_SR_LIST:
			state = {
				...state,
				// loading: false,
			};
			break;
		case PURCHASE_ORDER_SR_LIST_SUCCESS:
			state = {
				...state,
				CQPOList: action.payload,
				// loading: false,
			};
			break;
			case PURCHASE_ORDER_SR_DATA:
    		console.log("Action payload", action.payload);

    // Transform the payload to replace `cqitem_id` with `scqitem_id`
			const transformedPayload = action.payload.map((po) => {
				return {
					...po,
					poitems: po.poitems.map((item) => {
						const { cqitem_id, ...rest } = item; // Destructure to remove `cqitem_id`
						return {
							...rest,
							scqitem_id: cqitem_id, // Add `scqitem_id` with the value of `cqitem_id`
						};
					}),
				};
			});

			state = {
				...state,
				POData: transformedPayload,
				// HideSubmiteData: arr.length > 1, // Uncomment if `arr` logic is restored
			};
			break;
		case GENERATE_PURCHASE_ORDER_SR:
			state = {
				...state,
			};
			break;
		case GENERATE_PURCHASE_ORDER_SR_RESPONSE:
			var poData1 = state.POData.map((poList) => {
				if (poList.vendor_id === action.payload.data.vendor_id) {
					poList.loading = action.payload.loading;
					poList.requestStatus = action.payload.requestStatus;
				}
				return poList;
			});
			var arr1 = poData1.filter((poList) => {
				return poList.requestStatus === 2;
			});
			state = {
				...state,
				POData: poData1,
				HideSubmiteData: arr1.length > 1,
			};
			break;
		case SR_LIST_LAYOUT:
			state = {
				...state,
				layout: action.payload,
				loading: false,
			};
			break;
		case FILTERS_SHOW_SR_RIGHT_SIDEBAR:
			state = {
				...state,
				showFilterRightSidebar: !state.showFilterRightSidebar,
			};
			break;
		case FILTERS_HIDE_SR_RIGHT_SIDEBAR:
			state = {
				...state,

				showFilterRightSidebar: false,
			};
			break;
		case CLEAR_FILTER:
			state = {
				...state,
				filterdata: {},
			};
			break;
		case SR_PO_MODEL_OPEN:
			state = {
				...state,
				SR_PO_Model: true,
				SR_PO_ID: action.payload,
			};
			break;
		case SR_PO_MODEL_CLOSE:
			state = {
				...state,
				SR_PO_Model: false,
				SR_PO_index: null,
				PORowData: {},
			};
			break;
		case SR_PO_VEND_DATA:
			state = {
				...state,
				SR_PO_index: action.payload.index,
				PORowData: {},
			};
			break;
		case INPUT_CHANGEVALUE_SR:
			state = {
				...state,
				PORowData: {
					...state.PORowData,
					[action.payload.key]: action.payload.value,
				},
			};
			break;

		case RESET_SUBLOCATION:
			state = {
				...state,
				PORowData: {
					...state.PORowData,
					subLocationLabel: null,
					subLocationId: null,
				},
				sublocationslist2: { results: [] },
			};
			break;

		case SR_PO_SELECT_CHANGEVALUE_SR:
			state = {
				...state,
				PORowData: {
					...state.PORowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		default:
			state = { ...state };
			break;
	}

	return state;
};
export default SRCompareQuotation;
